module.exports = __webpack_public_path__ + "img/19.4f70ee53.jpg";